export default __webpack_public_path__ + "static/media/settingsWhite.19e0b86e.svg";